var _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 512,
    height: 336,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M512.2101449370384,167.8405797481537 H0.2101449370384217 V8.943579748153681 c0,-4.875 3.9530000000000003,-8.828 8.828,-8.828 h494.345 c4.875,0 8.828,3.9530000000000003 8.828,8.828 L512.2101449370384,167.8405797481537 L512.2101449370384,167.8405797481537 z",
    id: "svg_1",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M0.21014493703842163,167.8405797481537 h512 v158.897 c0,4.875 -3.9530000000000003,8.828 -8.828,8.828 H9.038144937038421 c-4.875,0 -8.828,-3.9530000000000003 -8.828,-8.828 V167.8405797481537 z",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M72.77914493703842,84.10357974815369 c0,-29.028 21.3,-53.091 49.113,-57.542 c1.51,-0.24200000000000021 1.578,-2.319 0.08800000000000023,-2.6630000000000003 c-6.886,-1.5830000000000002 -14.199,-2.034 -21.793,-1 c-29.998,4.086 -53.186,30.046 -53.61,60.318 c-0.4830000000000003,34.566 27.383,62.712 61.785,62.712 c4.683,0 9.23,-0.547 13.606,-1.554 c1.489,-0.3420000000000009 1.4140000000000001,-2.424 -0.0940000000000003,-2.6660000000000004 C94.07214493703842,137.26057974815367 72.77914493703842,113.24457974815368 72.77914493703842,84.10357974815369 z",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M122.35014493703842,99.63557974815367 l-2.613,7.836 l-8.259,0.06400000000000017 c-1.069,0.009000000000000036 -1.513,1.373 -0.6520000000000016,2.008 l6.644,4.907 l-2.492,7.875 c-0.3220000000000008,1.02 0.8390000000000006,1.863 1.7080000000000002,1.241 l6.72,-4.803 l6.72,4.803 c0.8700000000000013,0.6220000000000013 2.03,-0.2220000000000004 1.7080000000000002,-1.241 l-2.492,-7.875 l6.644,-4.907 c0.8610000000000013,-0.6360000000000015 0.4170000000000003,-1.999 -0.6520000000000016,-2.008 l-8.259,-0.06400000000000017 l-2.613,-7.836 C124.12314493703842,98.62157974815369 122.68814493703842,98.62157974815369 122.35014493703842,99.63557974815367 z",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M163.17714493703843,99.63557974815367 l-2.613,7.836 l-8.259,0.06400000000000017 c-1.069,0.009000000000000036 -1.513,1.373 -0.6520000000000016,2.008 l6.644,4.907 l-2.492,7.875 c-0.3220000000000008,1.02 0.8390000000000006,1.863 1.7080000000000002,1.241 l6.72,-4.803 l6.72,4.803 c0.8700000000000013,0.6220000000000013 2.03,-0.2220000000000004 1.7080000000000002,-1.241 l-2.492,-7.875 l6.644,-4.907 c0.8610000000000013,-0.6360000000000015 0.4170000000000003,-1.999 -0.6520000000000016,-2.008 l-8.259,-0.06400000000000017 l-2.613,-7.836 C164.95014493703843,98.62157974815369 163.51614493703843,98.62157974815369 163.17714493703843,99.63557974815367 z",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M142.94814493703842,36.63057974815369 l-2.613,7.836 l-8.259,0.06400000000000017 c-1.069,0.009000000000000036 -1.513,1.373 -0.6520000000000016,2.008 l6.644,4.907 l-2.492,7.875 c-0.3220000000000008,1.02 0.8390000000000006,1.863 1.7080000000000002,1.241 l6.72,-4.803 l6.72,4.803 c0.8700000000000013,0.6220000000000013 2.03,-0.2220000000000004 1.7080000000000002,-1.241 l-2.492,-7.875 l6.644,-4.907 c0.8610000000000013,-0.6360000000000015 0.4170000000000003,-1.999 -0.6520000000000016,-2.008 l-8.259,-0.06400000000000017 l-2.613,-7.836 C144.72114493703842,35.61657974815368 143.28614493703842,35.61657974815368 142.94814493703842,36.63057974815369 z",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M110.39614493703843,60.768579748153684 l-2.613,7.836 l-8.259,0.06400000000000017 c-1.069,0.009000000000000036 -1.513,1.373 -0.6520000000000016,2.008 l6.644,4.907 l-2.492,7.875 c-0.3220000000000008,1.02 0.8390000000000006,1.863 1.7080000000000002,1.241 l6.72,-4.803 l6.72,4.803 c0.8700000000000013,0.6220000000000013 2.03,-0.2220000000000004 1.7080000000000002,-1.241 l-2.492,-7.875 l6.644,-4.907 c0.8610000000000013,-0.6360000000000015 0.4170000000000003,-1.999 -0.6520000000000016,-2.008 l-8.259,-0.06400000000000017 l-2.613,-7.836 C112.16914493703842,59.754579748153674 110.73514493703843,59.754579748153674 110.39614493703843,60.768579748153684 z",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M175.22414493703843,60.768579748153684 l-2.613,7.836 l-8.259,0.06400000000000017 c-1.069,0.009000000000000036 -1.513,1.373 -0.6520000000000016,2.008 l6.644,4.907 l-2.492,7.875 c-0.3220000000000008,1.02 0.8390000000000006,1.863 1.7080000000000002,1.241 l6.72,-4.803 l6.72,4.803 c0.8700000000000013,0.6220000000000013 2.03,-0.2220000000000004 1.7080000000000002,-1.241 l-2.492,-7.875 l6.644,-4.907 c0.8610000000000013,-0.6360000000000015 0.4170000000000003,-1.999 -0.6520000000000016,-2.008 l-8.259,-0.06400000000000017 l-2.613,-7.836 C176.99714493703843,59.754579748153674 175.56214493703843,59.754579748153674 175.22414493703843,60.768579748153684 z",
    id: "svg_9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_10",
    className: ""
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_11",
    className: ""
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_12",
    className: ""
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13",
    className: ""
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14",
    className: ""
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15",
    className: ""
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16",
    className: ""
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17",
    className: ""
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18",
    className: ""
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "svg_19",
    className: ""
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "svg_20",
    className: ""
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_21",
    className: ""
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_22",
    className: ""
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_23",
    className: ""
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_24",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/si.d1897e9429217ba538f64e1bbe66fa8f.svg";
export { ForwardRef as ReactComponent };